import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f0c54c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal-box",
  ref: "target"
}
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-close" }
const _hoisted_4 = { class: "modal-scroll modal-border-space" }
const _hoisted_5 = { class: "modal-container" }
const _hoisted_6 = { class: "modal-separation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal-mask",
        id: "outside-modal",
        onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseDown && _ctx.handleMouseDown(...args))),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleOutsideClick && _ctx.handleOutsideClick(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _renderSlot(_ctx.$slots, "header", {}, undefined, true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.emit('modal-close')), ["stop"]))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "content", {}, undefined, true),
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
              ])
            ])
          ])
        ], 512)
      ], 32))
    : _createCommentVNode("", true)
}